module.exports = __webpack_public_path__ + "static/1.4_543x800_Mobile_Hero_2X-6cf0dc7922a518989043ae8577b05fdd.png";